import React, { CSSProperties } from 'react';
import Character from "./Character";
import { Avatar, makeStyles, Theme, createStyles, Card, CardHeader, CardContent, Typography, Divider } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import { SpriteDefine } from './SpriteManager';
import { Rating } from '@material-ui/lab';
import { useTranslation } from "react-i18next"

import  * as Lambda from "../../Lambda";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            margin: "auto",
        },
        avatar: {
            backgroundColor: red[500],
        },
        media: {
            height: 0,
            width: "100%",
            paddingTop: '56.25%', // 16:9
        },
    }),
);


interface Props {
    member?: Lambda.MemberType | undefined
    sprite?: SpriteDefine | undefined
    size?: string
}

function CharCard(props: Props) {

    const classes = useStyles()
    const [t] = useTranslation()

    const styles: {[key:string]:{[key:string]:CSSProperties}} = {
        small: {
            root: { width: 192 },
            avatar: { 
                width: 32,
                height: 32, 
            }
        },
        medium: {
            root: { width: 256 },
            avatar: { 
                width: 40,
                height: 40, 
            }
        },
        large: {
            root: { width: 320 },
            avatar: { 
                width: 48,
                height: 48, 
            }
        }
    }

    return props.member?.join ? (
        <Card className={classes.root} style={styles[props.size || "medium"]?.root} >
            <CardHeader
                avatar={
                    <Avatar
                        className={classes.avatar}
                        style={styles[props.size || "medium"]?.avatar}
                        src={props.member?.icon?.get}
                    >
                        {props.member.name.slice(0, 1)}
                    </Avatar>
                }
                title={props.member.name}
            />

            <CardContent>
                <Character
                    sprite={props.sprite}
                    character={props.member.avatar}
                />
            </CardContent>

            <CardContent>
                <Typography variant="body2" >{t("label.character.status")}</Typography>
                <Typography>
                    {t(`status.${props.member.status}`)}
                </Typography>                                    
                <Typography variant="body2" >{t("label.character.busyness")}</Typography>
                <Rating
                    value={props.member.busyness}
                    precision={0.5}
                    readOnly
                />
                <Typography variant="body2" >{t("label.character.comment")}</Typography>
                <Typography>
                    {props.member.comment}
                </Typography>     
                <Divider />
                {
                    /*
                    props.room?.fields?.map(field=>(
                        <div>
                            <Typography variant="body2" >{field.label}</Typography>
                            <Typography>
                                {props.member?.attributes[field.id]}
                            </Typography>  
                        </div>
                    ))
                    */
                }
            </CardContent>
        </Card>
    ) : (
        <Card className={classes.root} style={styles[props.size || "medium"]?.root} >
            <CardHeader
                avatar={
                    <Avatar
                        className={classes.avatar}
                        style={styles[props.size || "medium"]?.avatar}
                    >
                    </Avatar>
                }
                title={t("status.invite")}
            />

            <CardContent>
                <Character
                    sprite={props.sprite}
                />
            </CardContent>


        </Card>

    )
}
export default CharCard